// The location bar under the panel's header, on a brand with several locations (D4). Wording from the Amigo design's
// copy sheet (Location bar).
export default {
  label: 'Localização',
  all_one: 'Todas as {{count}} localizações',
  all_other: 'Todas as {{count}} localizações',
};
